module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wipes@3x_a6f431.png";